import { oc } from '@orpc/contract';
import { compareInputSchema, comparisonResultSchema } from '../schemas/compare.schemas.js';
export const compareVehiclesContract = oc
    .route({
    method: 'POST',
    path: '/compare',
    tags: ['Compare'],
    summary: 'Aggregate the selected runs of two to four vehicles and judge their comparability',
    description: 'The result panel of plan §7. Every selected run has to belong to its vehicle under the given scenario and be VALID or VALID_WITH_WARNING. The aggregation engine averages each vehicle’s selected runs, the compatibility engine judges the combined selection against the protocol’s checks, and the vehicle that used the most fuel becomes the baseline every percentage is measured against.',
})
    .input(compareInputSchema)
    .output(comparisonResultSchema);
//# sourceMappingURL=compare-vehicles.contract.js.map